import React, { useState } from "react";
import { useGet } from "../../hooks/api-call";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import {
  Box,
  Button,
  Collapse,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Grid,
} from "@mui/material";
import NumberInput from "../../atoms/NumberInput";

const OrderFilters = ({ fetchOrdersData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filters, setFilters] = useState({
    buyerId: "",
    materialId: "",
    tripStageId: "",
    minimumQuantity: "",
    poNumber: "",
  });

  const { responseData: buyers } = useGet("buyers");
  const { responseData: minerals } = useGet("minerals");
  const { responseData: poNumbers } = useGet("activeOrderIds");

  const handleChange = ({ target: { name, value } }) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = (data) => {
    fetchOrdersData("0", data || filters);
  };

  const handleClearFilters = () => {
    const data = {
      buyerId: "",
      materialId: "",
      tripStageId: "",
      minimumQuantity: "",
      poNumber: "",
    };
    setFilters(data);
    setTimeout(() => handleSearch(data), 100);
  };

  const handleOpenFilter = () => {
    setIsOpen((prev) => {
      const element = document.getElementById("truck-filter-section");
      if (prev) {
        element.style.height = "0px";
        setFilters({
          ownerId: "",
          driverId: "",
          truckHypothecated: "",
        });
      } else {
        setTimeout(() => {
          element.style.height = element.scrollHeight + "px";
        });
      }
      return !prev;
    });
  };

  return (
    <Box mt={4} p={2} boxShadow={3} borderRadius={2} bgcolor="#fff">
      <Box
        display="flex"
        alignItems="center"
        sx={{ cursor: "pointer", userSelect: "none" }}
        onClick={() => setIsOpen(!isOpen)}
        mb={isOpen ? 2 : 0}
      >
        {isOpen ? <BsChevronUp /> : <BsChevronDown />}
        <Typography ml={1} fontWeight="bold">
          Filter
        </Typography>
      </Box>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Box bgcolor="#f5f5f5" p={2} borderRadius={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>PO Number</InputLabel>
                <Select
                  name="poNumber"
                  value={filters.poNumber}
                  onChange={handleChange}
                  label="PO Number"
                >
                  {poNumbers?.map((po) => (
                    <MenuItem key={po.orderId} value={po.poNumber}>
                      {po?.poNumber}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Buyers</InputLabel>
                <Select
                  name="buyerId"
                  value={filters.buyerId}
                  onChange={handleChange}
                  label="Buyers"
                >
                  {buyers?.map((buyer) => (
                    <MenuItem key={buyer.buyerId} value={buyer.buyerId}>
                      {buyer.buyerName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Minerals</InputLabel>
                <Select
                  name="materialId"
                  value={filters.materialId}
                  onChange={handleChange}
                  label="Minerals"
                >
                  {minerals?.map((mineral) => (
                    <MenuItem
                      key={mineral.materialId}
                      value={mineral.materialId}
                    >
                      {mineral.materialName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                size="small"
                label="Quantity"
                name="minimumQuantity"
                value={filters.minimumQuantity}
                onChange={handleChange}
                type="number"
              />
            </Grid>
          </Grid>

          <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClearFilters}
              disabled={Object.values(filters).every((val) => val === "")}
            >
              Clear All
            </Button>
            <Button variant="contained" color="primary" onClick={() => handleSearch()}>
              Search
            </Button>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
};

export default OrderFilters;
